import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { registerMegaBroker, registerServices } from '@tencent/mega-mobile-preload';
import { callable } from '@tencent/tiny-ioc';
import { createNanoEvents } from 'nanoevents';
import { ClientVarsService } from '../../../core/services/client-vars-service';
import { SlideInitialDataService } from '../../../core/services/slide-initial-data-service';
import { SlideDataServices } from '../../../core/slide-data-services.core';
import { ILocalEditEventMap } from '../core/interfaces/local-edit-events.interface';
import { LocalEditServices } from '../core/local-edit-services.core';
import { createLocalEditClientVars } from '../loaders/local-edit-client-vars-loader';
import { LocalEditNoticeManager } from '../managers/local-edit-notice-manager';
import { MobileLocalEditManager } from '../scenes/mobile/managers/local-edit-manager.mobile';
import { PCLocalEditManager } from '../scenes/pc/managers/local-edit-manager.pc';
import { LocalEditContext } from '../services/local-edit-context';
import { DocxLocalEditDataConverter } from '../services/local-edit-data-converter.docx';
import { LocalEditService } from '../services/local-edit-service';
import { LocalSlideAppService } from '../services/slide-app-service.local';
import { LocalEditReporter } from '../services/local-edit-reporter';
import EmbeddedFontManager from '../managers/embedded-font-manager';
import { LocalSlideTitleManager } from '../managers/slide-title-manager.local';
import { LocalEditDocInfoManager } from '../core/managers/local-edit-doc-info-manager';
import { MobileDocVerifierManager } from '../scenes/mobile/managers/doc-verifier-manager.mobile';
import { PcDocVerifierManager } from '../scenes/pc/managers/doc-verifier-manager.pc';

export function registerLocalEditSlideDataServices() {
    // 创建并注册本地编辑上下文
    const context = new LocalEditContext();

    if (ENV.IS_MOBILE_LOCAL_EDIT) {
        registerMegaBroker();
        registerServices();
    }

    // 通过本地编辑上下文，创建 ClientVars
    SlideDataServices.ClientVarsService.register(() => new ClientVarsService(createLocalEditClientVars(context)));
    SlideDataServices.DocInfoManager.register(callable(LocalEditDocInfoManager));

    // 通过本地编辑服务加载初始数据后，注册到 SlideInitialDataService，之后会初始化 SlideAppService
    SlideDataServices.SlideInitialDataService.register(async () => {
        const localEditService = await LocalEditServices.LocalEditService.promise();
        const initialData = await localEditService.loadDocument();
        return new SlideInitialDataService(initialData);
    });

    // 注册本地 SlideApp 服务
    SlideDataServices.SlideAppService.register(callable(LocalSlideAppService));

    SlideDataServices.SlideTitleManager.register(callable(LocalSlideTitleManager));

    LocalEditServices.UI.ConvertErrorModal.register(async (...deps) => {
        const { ConvertErrorModal } = await import('../ui/convert-error-modal');
        return new ConvertErrorModal(...deps);
    });

    LocalEditServices.LocalEditContext.register(() => context);
    LocalEditServices.LocalEditEvents.register(() => createNanoEvents<ILocalEditEventMap>());
    LocalEditServices.LocalEditNoticeManager.register(callable(LocalEditNoticeManager));
    LocalEditServices.LocalEditReporter.register(callable(LocalEditReporter));

    // 注册本地编辑转换工具服务
    LocalEditServices.LocalEditDataConverter.register((...deps) => (
        new DocxLocalEditDataConverter(...deps)
    ));

    // 注册本地编辑服务
    LocalEditServices.LocalEditService.register(callable(LocalEditService));

    if (ENV.IS_MOBILE_LOCAL_EDIT) {
        LocalEditServices.LocalEditManager.register(callable(MobileLocalEditManager));
    } else {
        LocalEditServices.LocalEditManager.register(callable(PCLocalEditManager));
    }

    LocalEditServices.EmbeddedFontManager.register(callable(EmbeddedFontManager));

    // 注册文档密码校验manager
    if (ENV.IS_MOBILE_LOCAL_EDIT) {
        LocalEditServices.DocVerifierManager.register(callable(MobileDocVerifierManager));
    } else {
        LocalEditServices.DocVerifierManager.register(callable(PcDocVerifierManager));
    }


    if (__IS_DEV__) {
        // 开发环境注册到 window，方便调试
        Object.assign(window, { LocalEditServices });
    }
}
